import React from 'react';
import { Layout } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import { ExchangeRatesCard } from './components/ExchangeRatesCard';
import { SearchSettingsCard } from './components/SearchSettingsCard';
import { OrderSettingsCard } from './components/OrderSettingsCard';

import { useSettings } from '../hooks/data/useSettings';
import { DateUpdateFlexRow } from '../components/widgets/DateUpdateFlexRow';

export const SettingsPage = () => {

  const { settings, 
          lastUpdated, 
          error,
          refresh, 
          updateSearchSettings,
          updateSearchError, 
          updateOrderSettings,
          isLoading } = useSettings();

  return (
    <Layout.Content>
      <PageHeader title={'Settings'} />
      <DateUpdateFlexRow
        title={"Reload settings"}
        lastUpdated={lastUpdated}
        refreshCallback={refresh}/>

      <>
        <ExchangeRatesCard />
        <br />
        <OrderSettingsCard 
          isLoading={isLoading} 
          settings={settings} 
          updateOrderSettings={updateOrderSettings}/>
        <br />
        <SearchSettingsCard 
          isLoading={isLoading} 
          settings={settings}
          error={updateSearchError}
          updateSearchSettings={updateSearchSettings}/>
      </>

    </Layout.Content>
  );
};
